import React from "react";

const PrintFilledIcon = ({ cls }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="print (1) 1" clipPath="url(#clip0_3186_45279)">
        <path
          id="Vector"
          d="M17.2992 3.80001C17.2992 2.84523 16.9199 1.92956 16.2448 1.25443C15.5697 0.579297 14.654 0.200012 13.6992 0.200012L8.29922 0.200012C7.34444 0.200012 6.42877 0.579297 5.75363 1.25443C5.0785 1.92956 4.69922 2.84523 4.69922 3.80001V4.70001H17.2992V3.80001Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M14.5992 13.7H7.39922C5.90805 13.7 4.69922 14.9088 4.69922 16.4V19.1C4.69922 20.5912 5.90805 21.8 7.39922 21.8H14.5992C16.0904 21.8 17.2992 20.5912 17.2992 19.1V16.4C17.2992 14.9088 16.0904 13.7 14.5992 13.7Z"
          fill="currentColor"
        />
        <path
          id="Vector_3"
          d="M17.2992 6.5H4.69922C3.50618 6.50143 2.36242 6.97599 1.51882 7.8196C0.675213 8.6632 0.200648 9.80696 0.199219 11L0.199219 14.6C0.200369 15.4746 0.456354 16.3299 0.935868 17.0613C1.41538 17.7927 2.09764 18.3686 2.89922 18.7184V16.4C2.90065 15.207 3.37521 14.0632 4.21882 13.2196C5.06242 12.376 6.20618 11.9014 7.39922 11.9H14.5992C15.7923 11.9014 16.936 12.376 17.7796 13.2196C18.6232 14.0632 19.0978 15.207 19.0992 16.4V18.7184C19.9008 18.3686 20.5831 17.7927 21.0626 17.0613C21.5421 16.3299 21.7981 15.4746 21.7992 14.6V11C21.7978 9.80696 21.3232 8.6632 20.4796 7.8196C19.636 6.97599 18.4923 6.50143 17.2992 6.5ZM16.3992 10.1H14.5992C14.3605 10.1 14.1316 10.0052 13.9628 9.8364C13.794 9.66761 13.6992 9.43869 13.6992 9.2C13.6992 8.96131 13.794 8.73239 13.9628 8.5636C14.1316 8.39482 14.3605 8.3 14.5992 8.3H16.3992C16.6379 8.3 16.8668 8.39482 17.0356 8.5636C17.2044 8.73239 17.2992 8.96131 17.2992 9.2C17.2992 9.43869 17.2044 9.66761 17.0356 9.8364C16.8668 10.0052 16.6379 10.1 16.3992 10.1Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3186_45279">
          <rect
            width="21.6"
            height="21.6"
            fill="white"
            transform="translate(0.199219 0.200012)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PrintFilledIcon;
